import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['iframe', 'muteButton', 'playButton']
  static values = {
    muted: Boolean,
    muteText: String,
    unmuteText: String,
    muteLabel: String,
    unmuteLabel: String,
    play: Boolean,
    pauseText: String,
    playText: String,
    playLabel: String,
    pauseLabel: String,
  }

  connect() {
    if (!this.hasMutedValue) {
      this.mutedValue = true;
    }

    if (!this.hasPlayValue) {
      this.playValue = true;
    }

    this.player = null;
    this.playerReady = false;
    if (this.hasMuteButtonTarget) this.muteButtonTarget.disabled = true;

    this.waitForYouTubeAPI();
  }

  disconnect() {
    if (this.player) {
      this.player.destroy();
      this.player = null;
    }
  }

  toggleMute(event) {
    event.preventDefault();

    if (!this.playerReady) {
      return;
    }

    this.mutedValue = !this.mutedValue;

    if (this.mutedValue) {
      this.player.mute();
    } else {
      this.player.unMute();
    }

    this.updateMuteButtonLabel();
  }

  togglePlay(event) {
    // Ignore space key if focus is on an interactive element
    if (event.type === 'keydown' && event.target.matches('input, button')) {
      return;
    }

    event.preventDefault();

    if (!this.playerReady) return;

    this.playValue = !this.playValue;

    if (this.playValue) {
      this.player.playVideo();
    } else {
      this.player.pauseVideo();
    }

    this.updatePlayButtonLabel();
  }

  // private

  waitForYouTubeAPI() {
    if (window.YT && window.YT.Player) {
      this.createPlayer();
      return;
    }

    const previous = window.onYouTubeIframeAPIReady

    window.onYouTubeIframeAPIReady = () => {
      if (previous) previous();
      this.createPlayer();
    }
  }

  createPlayer() {
    this.player = new window.YT.Player(this.iframeTarget, {
      events: {
        onReady: this.onPlayerReady.bind(this),
      },
    })
  }

  onPlayerReady() {
    this.playerReady = true

    if (this.mutedValue) {
      this.player.mute();
    } else {
      this.player.unMute();
    }

    if (this.hasMuteButtonTarget) this.muteButtonTarget.disabled = false;
    this.updateMuteButtonLabel();
  }

  updateMuteButtonLabel() {
    if (this.hasMuteButtonTarget) {
      this.muteButtonTarget.innerHTML = this.mutedValue ? this.unmuteTextValue : this.muteTextValue;
      this.muteButtonTarget.setAttribute('aria-label', this.mutedValue ? this.unmuteLabelValue : this.muteLabelValue);
    }
  }

  updatePlayButtonLabel() {
    this.playButtonTarget.innerHTML = this.playValue ? this.pauseTextValue : this.playTextValue;
    this.playButtonTarget.setAttribute('aria-label', this.playValue ? this.pauseLabelValue : this.playLabelValue);
  }
}
